import {isDevEnv} from './platform';

type DataTestId = {
    'data-test-id'?: string;
    dataTestId?: string;
};

const styleKey = 'dataTestId';
const regKey = 'data-test-id';

export const createDataTestId = (id: string, isStyleComponent: boolean = false): DataTestId => {
    const isAutomation = window.location?.search?.toLowerCase().includes('_automation=1');
    if ((isDevEnv() || isAutomation) && id) {
        const key = isStyleComponent ? styleKey : regKey;
        return {[key]: id};
    } else {
        return {};
    }
};
